<app-header class="small-header" (reloadTemplate)="reloadInit()">
</app-header>


<div class="container" *ngIf="false">
  <div>
    <app-poshvine-search-widget></app-poshvine-search-widget>
  </div>

<div class="btn-section" >
  <app-poshvine-button [text]="'Claim offer'"></app-poshvine-button>
  <app-poshvine-button [text]="'Know more'" [type]="'secondary'"></app-poshvine-button>
</div>

<div class="btn-section" >
  <app-poshvine-card-primary ></app-poshvine-card-primary>
</div>

<app-poshvine-accordion [accordionItems]="accordionItems"></app-poshvine-accordion>

<div class="btn-section">
  <app-poshvine-voucher-card-secondary></app-poshvine-voucher-card-secondary>
</div>
<div class="btn-section" >
  <app-poshvine-offer-card></app-poshvine-offer-card>
</div>
<div class="btn-section" >
  <app-poshinve-voucher-card></app-poshinve-voucher-card>
</div>
<div class="btn-ection">
  <app-poshvine-link [labelText]="'Claim Now'"></app-poshvine-link>
</div>
</div>

<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->
<!-- * * * * * * * * * * * The content below * * * * * * * * * * * -->
<!-- * * * * * * * * * * is only a placeholder * * * * * * * * * * -->
<!-- * * * * * * * * * * and can be replaced. * * * * * * * * * * * -->
<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->
<!-- * * * * * * * * * Delete the template below * * * * * * * * * * -->
<!-- * * * * * * * to get started with your project! * * * * * * * * -->
<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->

<router-outlet></router-outlet>
<!-- <app-footer></app-footer> -->
